export enum RouteAlertName {
  Schedule = 'schedule',
  PublicTransportInfo = 'publicTransportInfo',
}
